import EmployeeService from "../../service/EmployeeService";
import swal from 'sweetalert'
//import router from "../../router";



export const state = {
    employees:[],
    employeeLoading: false,
    metrics: {
        type:'last30',
        startDate:null,
        endDate:null,
    },
    response:{}

}

export const mutations = {
    updateEmployees: (state, payload) =>{
        state.employees = payload
    },
    updateMetrics: (state, payload) =>{
        state.metrics = payload
    },
    updateEmployeeLoading: (state, payload) =>{
        state.employeeLoading = payload
    },
    updateResponse: (state, payload) =>{
        state.response = payload
    }
}

export const actions = {
    updateEmployees: ({ commit, state }, payload)=>{
        if(state.employees.length < 1)
            commit("updateEmployeeLoading", true)
        return EmployeeService.callReadApi(payload)
            .then(response => {
                commit("updateEmployeeLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateEmployeeLoading", false)
                    let responseData = response.data;
                    commit("updateEmployees", responseData.data)
                }

            })
            .catch(error => {
                commit("updateEmployeeLoading", false)
                alert(error)
                // throw error;
            });
    },
    createEmployee: ({ commit }, payload)=>{
        commit("updateEmployeeLoading", true)
        return EmployeeService.callCreateApi(payload)
            .then(response => {
                commit("updateEmployeeLoading", false)
                let responseData = response.data
                if (responseData.responseCode === "00") {
                    swal('Success!', responseData.responseMessage, 'success')
                }else{
                    swal('Error!', responseData.responseMessage, 'error')
                }
            })
            .catch(error => {
                commit("updateEmployeeLoading", false)
                alert(error)
                // throw error;
            });
    }
}